import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
import store from '@/store'
import Router from '@/router/index'
Vue.prototype.axios = axios
import crypto from 'crypto-js'
import tokenUtil from '@/utils/token'
// var baseurl = 'https://forumnewapi-dev.fgcq.info'; //开发环境
var baseurl = 'https://forumnewapi.fgcq.info'; //测试环境
// var baseurl = 'https://bbsnewapi.3975bbs.com'  //正式环境
// var baseurl = 'https://bbsnewapi-pre.3975bbs.com' //预发布环境
const baseURL = process.env.VUE_APP_INIT || baseurl;

export var backupDomains = [
  process.env.VUE_APP_INIT_BACK
];


function generateRandomString(length) {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;

  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result;
}
// var testyunUrl = 'http://frontyunsdksj.fgcq.info/home' // 云手机测试地址
// var yunUrl = 'https://yunsdkfrontsj-pre.cgodjk.com/home' // 云手机预发布地址
// var yunUrl = 'https://yunsdkfrontsj.fgcq.info/home' // 云手机正式地址
// var testplayUrl = 'http://yunadfront.fgcq.info' // 试玩测试地址
// var playUrl = 'https://yunad-pre.paopaoysj.com' // 试玩预发布地址
// var playUrl = 'https://yunad.paopaoysj.com' // 试玩正式地址

var yunUrl = process.env.VUE_APP_YUNURL
var playUrl = process.env.VUE_APP_PLAYURL
export { yunUrl, playUrl };

// axios.interceptors.request.use(config => {
//   config.headers.Authorization = window.sessionStorage.getItem('token')
//   return config
// })
//视频上传的地址
const base = 'https://videoupbbs.3975.com/interface/'

function uuid() {
  var s = [];
  var hexDigits = "0123456789abcdef";
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";

  var uuid = s.join("");
  return uuid;
}

// const MD5 = (value) => {
//   console.log(crypto.get(value));
//   return crypto.get(value)
// }
const MD5 = (value) => {
  return crypto.MD5(value).toString()
}
function getCookie(name) {
  var strcookie = document.cookie;//获取cookie字符串
  var arrcookie = strcookie.split("; ");//分割
  //遍历匹配
  for (var i = 0; i < arrcookie.length; i++) {
    var arr = arrcookie[i].split("=");
    if (arr[0] == name) {
      return arr[1];
    }
  }
  return "";
}


const sign = (params = {}) => {
  const keys = Object.keys(params).sort()
  const signs = []
  for (let key of keys) {
    if (params[key] == null) continue
    signs.push(`${key}=${params[key]}`)
  }
  signs.push(`key=Mjg3NTg0NDI`)
  return MD5(signs.join('&'))
}

const normalizeBaseURL = (url) => {
  if (!url) return ''
  return String(url).replace(/\/+$/, '')
}

const buildDomainCandidates = () => {
  const candidates = [baseURL, ...(backupDomains || [])]
    .map(normalizeBaseURL)
    .filter(Boolean)
  return Array.from(new Set(candidates))
}

const domainCandidates = buildDomainCandidates()
let activeBaseURL = normalizeBaseURL(baseURL)

const setActiveBaseURL = (nextBaseURL) => {
  const normalized = normalizeBaseURL(nextBaseURL)
  if (!normalized) return
  activeBaseURL = normalized
}

const getNextBaseURL = (currentBaseURL) => {
  const normalized = normalizeBaseURL(currentBaseURL)
  const index = domainCandidates.indexOf(normalized)
  if (index < 0) return domainCandidates[0]
  return domainCandidates[(index + 1) % domainCandidates.length]
}

const shouldSwitchDomain = (error) => {
  if (!domainCandidates.length || domainCandidates.length <= 1) return false
  if (!error) return false
  if (error.response && error.response.status) {
    const status = error.response.status
    if (status >= 500) return true
  }
  if (error.code === 'ECONNABORTED') return true
  const msg = String(error && error.message ? error.message : error)
  if (msg.includes('Network Error')) return true
  if (!error.response) return true
  return false
}

const httpRequest = ({ method = 'GET', url = '', headers = {} } = {}, body) => {
  const xhr = new XMLHttpRequest()
  return new Promise((resolve, reject) => {
    xhr.open(method, activeBaseURL + url, true)
    for (let [key, value] of Object.entries(headers)) {
      xhr.setRequestHeader(key, value)
    }
    xhr.onload = ({ target }) => {
      if (target.status == 200 && target.response) {
        resolve(JSON.parse(target.response))
      } else {
        resolve({ msg: xhr.statusText });
      }
    }
    xhr.send(body)
  })
}
const http = ({ method = 'GET', url = '', headers = {} } = {}, body) => {
  const xhr = new XMLHttpRequest()
  return new Promise((resolve, reject) => {
    xhr.open(method, base + url, true)
    for (let [key, value] of Object.entries(headers)) {
      xhr.setRequestHeader(key, value)
    }
    xhr.onload = ({ target }) => {
      if (target.status == 200 && target.response) {
        resolve(JSON.parse(target.response))
      } else {
        resolve({ msg: xhr.statusText });
      }
    }
    xhr.send(body)
  })
}

const instance = axios.create({
  baseURL: activeBaseURL,
  timeout: 30000,
  withCredentials: false,
  headers: {
    'Accept': 'application/json, text/plain, */*',
    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
  },
  transformRequest: data => qs.stringify(data)
})
const customerRequest = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? '' : 'https://livechat.39center.com',
  timeout: 30000,
  withCredentials: false,
  headers: {
    'Accept': 'application/json, text/plain, */*',
    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
  },
  transformRequest: data => qs.stringify(data)
});
customerRequest.interceptors.response.use(
  (res) => {
    return res.data
  },
  (err) => {
    console.log(err);
  }
)
export { customerRequest }


// 添加响应拦截器
instance.interceptors.request.use(config => {
  if (config && config.__rawData === undefined) {
    config.__rawData = config.data
  }
  if (config && config.__rawParams === undefined) {
    config.__rawParams = config.params
  }
  if (config && !config.baseURL) {
    config.baseURL = activeBaseURL
  }
  return config
})

instance.interceptors.response.use(response => {
  const { status, data } = response;

  if (status === 200) {
    // 未登录，未授权
    if (data.code === 402 || data.code == 401) {
      // uni.$toast(data.msg);
      store.dispatch('logout');
      store.commit('popup/setloginpop', true)
    }
    // 账号被封禁
    else if (data.code === 408) {
      if (!store.state.popup.forbid) {
        // uni.$c.sealGamePopup({ flag: true, data: data.data })
      }

    }
    // 强制更新
    else if (data.code === 403) {

    }
    return data;
  } else {
    return Promise.reject(new Error('Server Unknown Error'));
  }
}, error => {
  if (error.toString() != 'Error: Network Error') {
    store.dispatch('pushError', error.toString())
  }
  const config = error && error.config
  if (!config || !shouldSwitchDomain(error)) {
    return Promise.resolve(error)
  }

  const tried = Array.isArray(config.__domainTried) ? config.__domainTried : []
  const current = normalizeBaseURL(config.baseURL || instance.defaults.baseURL || activeBaseURL)
  const next = getNextBaseURL(current)
  if (!next || tried.includes(next) || tried.length >= domainCandidates.length - 1) {
    return Promise.resolve(error)
  }

  config.__domainTried = [...tried, next]
  config.baseURL = next
  instance.defaults.baseURL = next
  setActiveBaseURL(next)

  if (config.__rawData !== undefined) config.data = config.__rawData
  if (config.__rawParams !== undefined) config.params = config.__rawParams

  return instance.request(config)
})



const Ajax = async (url, data = {}, conf = {}) => {

  const token = tokenUtil.read();
  // js获取设备类型
  let ua = navigator.userAgent.toLowerCase();
  let isAndroid = ua.indexOf("android") > -1;
  let isIos = ua.indexOf("iphone") > -1;
  var platform = 'pc'
  if (isAndroid) {
    platform = 'android'
  } else if (isIos) {
    platform = 'ios'
  }
  const conversationId = MD5(token + 'wfasfj');
  const timistamp = new Date().getTime()
  let rs
  // || url == 'login-with-code'
  var params = {}
  rs = await instance({
    url,
    method: 'post',
    headers: {
      platform,
      AUTHORIZATION: token,
    },
    data: {
      ...data,
      ...params,
      sign: sign({ ...data, conversationId, timistamp }),
      conversationId,
      timistamp
    },

    ...conf
  })
  return rs
}

export { baseURL, Ajax, httpRequest, MD5, http }
export default Ajax